import { useWorkspace } from '@/features/workspaces/hooks';
import { DataSourceFileConfig, TDataSource } from '@/models/dataSource';
import { useLazyGetDataSourceFileLinesQuery } from '@/services/dataSources';
import { FC, useEffect, useState } from 'react';
import * as csvParser from 'papaparse';
import { FileElementsTable } from './FileElementsTable';
import { Loadable } from '@/components/loaders';

type FileElementsPreviewProps = {
  dataSource: TDataSource<DataSourceFileConfig>;
};

export const FileElementsPreview: FC<FileElementsPreviewProps> = ({ dataSource }) => {
  const workspace = useWorkspace();

  const [getDataSourceFileLines, { data: lines, isLoading: isLoadingLines }] = useLazyGetDataSourceFileLinesQuery();
  const [parsedFileLines, setParsedFileLines] = useState<string[][]>([]);

  useEffect(() => {
    if (dataSource) {
      getDataSourceFileLines({
        workspaceId: workspace.id,
        dataSourceId: dataSource.id,
      });
    }
  }, []);

  useEffect(() => {
    if (lines) {
      const results = csvParser.parse(lines.join('\n'), {
        skipEmptyLines: true,
      });
      setParsedFileLines((results?.data as string[][]) || []);
    }
  }, [lines]);

  return (
    <Loadable isLoading={isLoadingLines} loadingMessage='ALL:data_sources.loadingFileElementsPreviewTable' className='pb-8 pt-2'>
      <FileElementsTable dataSource={dataSource} fileContent={parsedFileLines} isDefaultHeaderCorrect={dataSource?.configuration.isDefaultHeader} />
    </Loadable>
  );
};
